module.exports = __webpack_public_path__ + "static/media/titekarela.16c4e104.ogg";